import {
  CcfBox,
  CcfHistoryIcon,
  CcfNoRequestFoundIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { CcfWemTable } from './ccf-wem-table';
import { useState } from 'react';

/* eslint-disable-next-line */
export interface CcfWemScheduleRequestesProps {}

/**
 * CcfWemScheduleRequestes - used to display wem schedule requests
 * @param props - CcfWemScheduleRequestes
 * @example `<CcfWemScheduleRequestes />`
 */
export function CcfWemCcfWemScheduleRequestes(
  props: CcfWemScheduleRequestesProps
) {
  const shiftTradeTypeColumns = [
    {
      field: 'requestedDate',
      headerName: 'REQUESTED DATE',
      width: 180,
      flex: 1,
    },
    {
      field: 'requestedTime',
      headerName: 'REQUESTED TIME',
      width: 170,
      flex: 1,
    },
    {
      field: 'requestType',
      headerName: 'REQUEST TYPE',
      width: 180,
      flex: 1,
    },
    {
      field: 'requestedon',
      headerName: 'REQUESTED ON',
      width: 200,
      flex: 1,
    },
    {
      field: 'tradeWith',
      headerName: 'TRADE WITH',
      width: 200,
      flex: 1,
    },
    {
      field: 'tradeType',
      headerName: 'TRADE TYPE',
      width: 200,
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'STATUS',
      width: 150,
      flex: 1,
    },
    {
      field: 'reviewdby',
      headerName: 'REVIEWED BY',
      width: 150,
      flex: 1,
    },
    {
      field: 'actions',
      headerName: 'ACTIONS',
      width: 150,
      flex: 1,
    },
  ];

  const activityTypeColumns = [
    {
      field: 'requestedDates',
      headerName: 'REQUESTED DATES',
      minWidth: 130,
    },
    {
      field: 'requestedTime',
      headerName: 'REQUESTED TIME',
      width: 150,
    },
    {
      field: 'activityType',
      headerName: 'ACTIVITY TYPE',
      width: 130,
      renderCell: (params: any) => (
        <CcfBox style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <img
            src="./assets/ActivityTypeIcon.png"
            alt="addActivityIcon"
            style={{ width: '16px' }}
          />

          <div className={styles.statusIcon} />
          {params.value}
        </CcfBox>
      ),
    },
    {
      field: 'requestedon',
      headerName: 'REQUESTED ON',
      width: 200,
    },
    {
      field: 'agentcomment',
      headerName: 'AGENT COMMENT',
      width: 120,
      
    },
    {
      field: 'reviewdby',
      headerName: 'REVIEWED BY',
      minWidth: 90,
    },
    {
      field: 'reviewerComments',
      headerName: 'REVIEWER COMMENTS',
      width: 130,
    },
    {
      field: 'status',
      headerName: 'STATUS',
      minWidth: 100,
      renderCell: (params: any) => {
        console.log('params', params);
        return (
          <CcfBox
            style={{ display: 'flex', alignItems: 'flex-start', gap: '5px' }}
          >
            {params.row.status === 'Pending' ? (
              <CcfHistoryIcon />
            ) : params.row.status === 'Canceled' ? (
              <img
                src="./assets/canceledIcon.png"
                alt="canceledIcon"
                style={{ width: '16px', marginRight: '9px' }}
              />
            ) : null}

            {params.value}
          </CcfBox>
        );
      },
    },
  ];
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  /**@example */
  const getFormattedDate = () => {
    const today = new Date();
    return today.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });
  };

  /**@example */
  const getFormattedDateTime = () => {
    const today = new Date();
    return today.toLocaleString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };
  const activityRequestRowData = [
    {
      id: 0,
      requestedDates: getFormattedDate(),
      requestedTime: '3.00 PM - 4.00 PM',
      activityType: 'Lunch',
      requestedon: getFormattedDateTime(),
      agentcomment: 'on lunch break',
      reviewerComments: '-',
      status: 'Pending',
      reviewdby: '-',
    },
    {
      id: 1,
      requestedDates: getFormattedDate(),
      requestedTime: '4.30 PM - 4.45 PM',
      activityType: 'Break',
      requestedon: getFormattedDateTime(),
      agentcomment: 'on break',
      reviewerComments: '-',
      status: 'Canceled',
      reviewdby: 'System',
    },
  ];
  /**
   *
   * @example - noDataFound()
   */
  const noRequestFound = () => {
    return (
      <CcfBox className={styles.tableDataContainer}>
        <CcfBox className={styles.noDataFoundBlock}>
          <CcfNoRequestFoundIcon style={{ fontSize: 240 }} />
          <CcfTypography className={styles.noRequestTxt}>
            No request was created yet
          </CcfTypography>
        </CcfBox>
      </CcfBox>
    );
  };

  /**
   *
   * @example - handleTabChange()
   */
  const handleTabChange = (tabIndex: any) => {
    setSelectedTabIndex(tabIndex);
  };

  return (
    <CcfBox className={styles.wemScheduleContainer}>
      <CcfBox>
        <CcfTypography className={styles.wemTabTitle}>
          Schedule Requests
        </CcfTypography>
      </CcfBox>
      <CcfBox className={styles.tabSection}>
        <CcfBox
          className={`${styles.tabs} ${
            selectedTabIndex === 0 ? styles.selectedTab : ''
          }`}
          onClick={() => handleTabChange(0)}
        >
          Activity Requests
        </CcfBox>
        <CcfBox
          className={`${styles.tabs} ${
            selectedTabIndex === 1 ? styles.selectedTab : ''
          }`}
          onClick={() => handleTabChange(1)}
        >
          Shift Trade Requests
        </CcfBox>
      </CcfBox>
      <CcfWemTable
        columns={
          selectedTabIndex === 0 ? activityTypeColumns : shiftTradeTypeColumns
        }
        rowData={selectedTabIndex === 0 ? activityRequestRowData : []}
        tableHeaderText={
          selectedTabIndex === 0
            ? `${activityRequestRowData.length} Requests`
            : '0 Requests'
        }
        noDataFound={noRequestFound()}
        isSelectRequired={true}
      />
    </CcfBox>
  );
}
